
document.addEventListener('DOMContentLoaded', () => {
  const details = document.querySelectorAll('details');

  details.forEach((detail) => {
    let isAnimating = false;

    detail.addEventListener('click', (e) => {
      // Only handle clicks on the summary
      if (e.target.tagName !== 'SUMMARY' && !e.target.closest('summary')) return;

      e.preventDefault();
      
      if (isAnimating) return;

      const summary = detail.querySelector('summary');
      const content = detail.querySelector('.accordion-content');
      
      if (!content) return; // Fallback for standard details

      isAnimating = true;

      // Check if currently opening or closing
      if (detail.hasAttribute('open')) {
        // Closing
        // 1. Set height to current fixed height to enable transition
        const startHeight = content.offsetHeight;
        content.style.height = `${startHeight}px`;
        content.style.overflow = 'hidden';
        content.style.transition = 'height 0.4s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.3s ease';
        content.style.opacity = '1';

        // 2. Force reflow
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
             // 3. Set height to 0
            content.style.height = '0px';
            content.style.opacity = '0';
          });
        });

        // 4. Wait for transition to finish before removing 'open'
        const onEnd = () => {
          detail.removeAttribute('open');
          content.style.height = '';
          content.style.overflow = '';
          content.style.opacity = '';
          content.style.transition = '';
          content.removeEventListener('transitionend', onEnd);
          isAnimating = false;
        };
        content.addEventListener('transitionend', onEnd, { once: true });

      } else {
        // Opening
        // 1. Add 'open' attribute
        detail.setAttribute('open', '');
        
        // 2. Get the natural height of content
        content.style.height = 'auto';
        const endHeight = content.scrollHeight;
        
        // 3. Set initial state for transition
        content.style.height = '0px';
        content.style.opacity = '0';
        content.style.overflow = 'hidden';
        content.style.transition = 'height 0.4s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.3s ease';
        
        // 4. Force reflow
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
             // 5. Transition to full height
            content.style.height = `${endHeight}px`;
            content.style.opacity = '1';
          });
        });
        
        // 6. Cleanup after transition
        const onEnd = () => {
          content.style.height = 'auto';
          content.style.overflow = '';
          content.style.opacity = '';
          content.style.transition = '';
          content.removeEventListener('transitionend', onEnd);
          isAnimating = false;
        };
        content.addEventListener('transitionend', onEnd, { once: true });
      }
    });
  });
});
